import { createContext, useState, useContext, useEffect } from "react";
import axiosInstance from "../utils/axios";
import { examUrlParams } from "../utils/urlParams";
import { AUTH_KEYS } from "../constants/storageKeys";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const { token, sessionId } = examUrlParams;

        localStorage.setItem(AUTH_KEYS.TOKEN, token);
        if (sessionId) {
          localStorage.setItem(AUTH_KEYS.SESSION_ID, sessionId);
        }

        if (!token) {
          throw new Error("No token found in URL");
        }

        // const response = await axios.get(
        //   `${process.env.REACT_APP_API_URL}/user/get-user`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${token}`,
        //     },
        //     withCredentials: true,
        //   }
        // );

        const response = await axiosInstance.get("/user/get-user");
        setUser(response.data.user);
      } catch (error) {
        console.error("Failed to fetch user", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return (
    <UserContext.Provider value={{ user, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
